import _ from "lodash"

import Model from "../../model"
import assert from "../../../services/assert"
import { ID, Location, ideaHeight, ideaWidth } from "../../types"
import Command, { CommandName } from "../command"

export type MoveIdeasCommandState = {
  ideaLocations: [ID, Location][]
  updatedAt?: Date
  captured?: {
    prevIdeaLocations: [ID, Location][]
  }
}

export default class MoveIdeasCommand extends Command {
  name: CommandName = "move-ideas"
  state: MoveIdeasCommandState

  constructor(state: MoveIdeasCommandState) {
    super()
    this.state = state
  }

  // Possible conflicts:
  //   - idea might have been deleted (Resolve, Cancel)
  //   - another idea might be in the spot (Resolve)
  resolveConflicts(model: Model): MoveIdeasCommandState | null {
    const ideaLocations: [ID, Location][] = this.state.ideaLocations.filter(
      ([id, _]) => !!model.getIdea(id)
    )

    const ideaLocations2: [ID, Location][] = ideaLocations.map(
      ([id, location]) => {
        const idea = model.fetchIdea(id)
        if (
          !model.isAvailableLocationIgnoring(
            location,
            ideaWidth(idea),
            ideaHeight(idea),
            ideaLocations.map(([id, _]) => id)
          )
        ) {
          return [
            id,
            model.getNearestAvailableLocationIgnoring(
              location,
              ideaWidth(idea),
              ideaHeight(idea),
              ideaLocations.map(([id, _]) => id)
            ),
          ]
        } else {
          return [id, location]
        }
      }
    )

    return ideaLocations2.length
      ? { ..._.cloneDeep(this.state), ideaLocations: ideaLocations2 }
      : null
  }

  local(model: Model): any {
    this.state.captured = {
      prevIdeaLocations: this.state.ideaLocations.map(([id, _]) => [
        id,
        model.fetchIdea(id).location,
      ]),
    }

    model.moveIdeas(this.state.ideaLocations, this.state.updatedAt)
  }

  undo(): Command[] {
    assert(this.state.captured?.prevIdeaLocations)
    return [
      new MoveIdeasCommand({
        ideaLocations: this.state.captured.prevIdeaLocations,
      }),
    ]
  }
}
